import React, { useState, useEffect, useRef } from 'react';
import './Imageslider.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Imageslider = () => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState('next');
  const sliderRef = useRef(null);
  
  const images = [
    { id: 1, src: './img1.jpg', caption: 'DOLOR SIT AMET' },
    { id: 2, src: './img2.jpg', caption: 'CONSECTETUR ADIPISCING' },
    { id: 3, src: './img3.png', caption: 'EIUSMOD TEMPOR' },
    { id: 4, src: './img4.png', caption: 'INCIDIDUNT UT' },
    { id: 5, src: './img5.png', caption: 'LABORE ET DOLORE' }
  ];

  // Handle next slide
  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setDirection('next');
    setCurrentIndex(prev => (prev + 1) % images.length);
  };

  // Handle previous slide
  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setDirection('prev');
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };

  // Reset animation state
  useEffect(() => {
    if (isAnimating) {
      const timer = setTimeout(() => setIsAnimating(false), 600);
      return () => clearTimeout(timer);
    }
  }, [isAnimating]);

  // Get visible images (center, left, right)
  const getVisibleImages = () => {
    const leftIndex = (currentIndex - 1 + images.length) % images.length;
    const rightIndex = (currentIndex + 1) % images.length;
    
    return [
      { ...images[leftIndex], position: 'left', slideDirection: direction },
      { ...images[currentIndex], position: 'center', slideDirection: direction },
      { ...images[rightIndex], position: 'right', slideDirection: direction }
    ];
  };

  // Auto slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAnimating) {
        nextSlide();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [isAnimating]);

  const visibleImages = getVisibleImages();

  return (
    <section className="image-slider-section">
      <div className="slider-container">
        <div 
          className="slider-track" 
          ref={sliderRef}
          data-animating={isAnimating}
          data-direction={direction}
        >
          {visibleImages.map((image) => (
            <div 
              key={`${image.id}-${image.position}`}
              className={`slider-panel ${image.position}-panel slide-${image.slideDirection}`}
              data-position={image.position}
            >
              <div className="image-container">
                <img 
                  src={image.src} 
                  alt={image.caption}
                  className="slider-image"
                  loading="lazy"
                />
                <div className="image-overlay"></div>
                <div className="image-caption">
                  <span className="caption-text">{image.caption}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button 
          className="slider-arrow prev-arrow" 
          onClick={prevSlide}
          disabled={isAnimating}
          aria-label="Previous slide"
        >
          <ArrowBackIcon />
        </button>
        
        <button 
          className="slider-arrow next-arrow" 
          onClick={nextSlide}
          disabled={isAnimating}
          aria-label="Next slide"
        >
          <ArrowForwardIcon />
        </button>

        {/* Dots Indicator */}
        <div className="slider-dots">
          {images.map((_, index) => (
            <button
              key={index}
              className={`slider-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => {
                if (!isAnimating && index !== currentIndex) {
                  setIsAnimating(true);
                  setDirection(index > currentIndex ? 'next' : 'prev');
                  setCurrentIndex(index);
                }
              }}
              disabled={isAnimating}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Imageslider;